import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { saveAs } from 'file-saver';
import { OFFICIAL_LAYOUT, INVALID_LAYOUT, DEFAULT_BASIC_LAYOUT } from '../../../constants/defaults';
import { notifyError } from '../../../utils/notifier';
import { toTimeString } from '../../../utils/dates';
import Table from '../../shared/Table';
import Button from '../../shared/Button';
import styles from './styles.scss';
import { downloadReport, getDeviceTypes } from '../../../actions/tests/apiRequests';
import { SYSTEMS_OF_MEASURE } from '../../../constants/uom';
import { getMDCAverageRadonValue } from '../../../utils/uom';
import { isNil } from 'lodash';

const getReportCanBeGenerated = (isBasic, isTestValid, canReportBeGenerated, deviceLastCalibrationDate) => {
  if (isNil(deviceLastCalibrationDate)) return false;
  if (isBasic) return true;
  if (isNil(isTestValid) || isNil(isTestValid)) return false;
  return canReportBeGenerated;
};

const getReportLayout = (isBasic, isTestValid, defaultLayout) => {
  if (isBasic) {
    return defaultLayout == null || defaultLayout === OFFICIAL_LAYOUT ? DEFAULT_BASIC_LAYOUT : defaultLayout;
  }
  return isTestValid ? OFFICIAL_LAYOUT : INVALID_LAYOUT;
};

export class TestsListTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceTypes: {
        RS300: 'RS300',
        RS800: 'RS800',
        SN1027: 'SN1027',
        ALPHA310: 'ALPHA310',
        ALPHA516: 'ALPHA516',
        ALPHA830: 'ALPHA830',
      },
    };
    this.onReportClick = this.onReportClick.bind(this);
  }

  get headers() {
    return [
      ['Client Name', 'ContactName'],
      ['Start Date', 'StartDate'],
      ['Address', 'Address'],
      ['Radon Average Result', 'RadonAverage'],
      ['Client Email', 'ContactEmail'],
      ['Status', 'Status'],
      ['QC', 'QC'],
      ['Tester Name', 'Tester'],
      ['Device SN', 'DeviceSN'],
      ['Instrument Location', 'InstrumentLocation'],
      ['', ''],
    ];
  }

  get rows() {
    const { unitsOfMeasure, tzAbbr } = this.props;
    const { deviceTypes } = this.state;
    return this.props.tests.map((test) => [
      test.clientName,
      test.startDate && toTimeString(test.startDate, tzAbbr),
      `${test.address1 || ''} ${test.address2 || ''}`,
      typeof test.averageRadon === 'number'
        ? `${getMDCAverageRadonValue(test, unitsOfMeasure, deviceTypes)} ${SYSTEMS_OF_MEASURE[unitsOfMeasure].radon}`
        : null,
      test.clientEmail,
      test.isCompleted ? 'Complete' : 'Incomplete',
      test.qc ? <img src="/qc_icon.png" className={`${styles.qcIcon}`} /> : '',
      test.testerName,
      test.deviceSN,
      test.instrumentLocation,
      this.getActions(
        test.id,
        test.hasData,
        test.isCompleted,
        test.layoutTemplateId,
        getReportCanBeGenerated(
          test.isBasic,
          test.isTestValid,
          test.canReportBeGenerated,
          test.deviceLastCalibrationDate,
        ),
        getReportLayout(test.isBasic, test.isTestValid, this.props.reportLayout),
      ),
    ]);
  }

  componentDidMount() {
    getDeviceTypes()
      .then((deviceTypes) => {
        this.setState({
          deviceTypes,
        });
      })
      .catch(console.error);
  }

  render() {
    const { tests, sortAsc, sortTable, sortedColumn } = this.props;

    return (
      <If condition={tests && tests.length}>
        <div className="text-center">
          <Table
            sortableHeaders={this.headers}
            rows={this.rows}
            sortable={true}
            sortAction={sortTable}
            sortAsc={sortAsc}
            sortedColumn={sortedColumn}
          />
        </div>
      </If>
    );
  }

  onReportClick(event, testId, reportLayout) {
    event.preventDefault();

    return downloadReport(testId, reportLayout)
      .then((blob) => saveAs(blob, 'report.pdf'))
      .catch(() => notifyError());
  }

  getActions(testId, hasTestData, isTestCompleted, layoutTemplateId, canReportBeGenerated, reportLayout) {
    const pathName = !!layoutTemplateId ? `/dynamictests/${testId}` : `/tests/${testId}`;
    return (
      <div className="dropdown">
        <Button className="dropdown-toggle" kind="borderless" data-toggle="dropdown">
          Actions
        </Button>
        <div className="dropdown-menu dropdown-menu-left">
          <Link
            to={{
              pathname: pathName,
              state: { editMode: false },
            }}
            className="dropdown-item"
          >
            <i className={`fa fa-file mr-2 ${styles.actionIcon}`} />
            View
          </Link>
          <Link
            to={{
              pathname: pathName,
              state: { editMode: true },
            }}
            className="dropdown-item"
          >
            <i className={`fa fa-pencil mr-2 ${styles.actionIcon}`} />
            Edit
          </Link>
          <If condition={hasTestData && isTestCompleted && canReportBeGenerated}>
            <a className="dropdown-item" href="#" onClick={(e) => this.onReportClick(e, testId, reportLayout)}>
              <i className={`fa fa-download mr-2 ${styles.actionIcon}`} />
              Report
            </a>
          </If>
        </div>
      </div>
    );
  }
}

TestsListTable.propTypes = {
  tests: PropTypes.array,
  isSpruceAdmin: PropTypes.bool,
  reportLayout: PropTypes.string,
  unitsOfMeasure: PropTypes.string,
  tzAbbr: PropTypes.string,
  sortTable: PropTypes.func,
  sortAsc: PropTypes.bool,
  sortedColumn: PropTypes.string,
};

export default TestsListTable;



// WEBPACK FOOTER //
// src/components/testsList/TestsListTable/index.jsx